import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
const BeforeAfterSlider = {
    sliderContainer: null,
    slider: null,

    init: function () {
        this.sliderContainer = document.getElementById('slide-before-after');

        if (this.sliderContainer) {
            this.initSlider();
        }
    },

    initSlider: function () {
        const container = this.sliderContainer;
        const sliderElement = container.querySelector(
            '.js-slider-before-after-list'
        );

        if (!sliderElement) {
            return;
        }

        if (sliderElement.swiper) {
            this.slider = sliderElement.swiper;
            return this.slider;
        }

        this.slider = new Swiper(sliderElement, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            autoHeight: true,
            allowTouchMove: true,
            loop: false,
            watchOverflow: false,

            navigation: {
                prevEl: container.querySelector('.js-slider-before-after-prev'),
                nextEl: container.querySelector('.js-slider-before-after-next'),
            },

            pagination: {
                el: container.querySelector('.js-slider-before-after-pagination'),
                type: 'bullets',
                clickable: true,
                dynamicBullets: false,
            },
        });

        return this.slider;
    },
};

export function initBeforeAfterSlider() {
    BeforeAfterSlider.init();
}